import { Routes } from '@common/constants';
import { omit } from 'lodash';
import type { ParsedUrlQuery } from 'querystring';

type BookableType = 'room' | 'rate';

export const isSpaStaysPathname = (pathname = '') =>
  pathname === Routes.SPA_STAYS_LIST || pathname.startsWith(`${Routes.SPA_STAYS_LIST}/`);

export const getBookingRoute = (pathname?: string, type: BookableType = 'rate'): Routes => {
  if (type === 'room') return Routes.ROOM_BOOKING;

  return isSpaStaysPathname(pathname) ? Routes.SPA_STAYS_BOOKING : Routes.RATE_BOOKING;
};

export const getDetailRoute = (pathname?: string, type: BookableType = 'rate'): Routes => {
  if (type === 'room') return Routes.ROOM_DETAIL;

  return isSpaStaysPathname(pathname) ? Routes.SPA_STAYS_DETAIL : Routes.RATE_DETAIL;
};

export const getDetailQuery = (
  bookingQuery: ParsedUrlQuery,
  id: string | undefined
): ParsedUrlQuery => ({
  ...omit(bookingQuery, ['bookingStep', 'room']),
  id,
});
